import styled from 'styled-components';
import theme from '../../styles/theme';

const HighlightedVars = styled.span`
  background-color: ${theme.colors.red.normal}4D;
  color: black !important;
  /* white-space: nowrap; */
  font-weight: 600;
  margin-right: 0px !important;
`;

const TextWrap = styled.div`
  display: inline;
  word-break: normal;
  min-width: 0; /* ← CRITICAL */
  white-space: pre-wrap; /* allow wrapping */
  word-break: break-word; /* break long words */
`;

const HighlightVars = (message?: string) => {
  if (typeof message !== 'string' || !message) return;
  const transformedText = message
    .replaceAll('\\n', '<br />')
    .split(/(#{\w+})/)
    .map((part, index) => {
      if (part.startsWith('#{') && part.endsWith('}')) {
        return (
          <HighlightedVars key={`HighlightedVars-${index}-${part}`}>
            {part}
          </HighlightedVars>
        );
      }

      return part;
    });

  return <TextWrap>{transformedText}</TextWrap>;
};

export default HighlightVars;
